import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekday from "dayjs/plugin/weekday";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 확장 플러그인 등록
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (date: string | Date, format = "YYYY-MM-DD") =>
    dayjs(date).format(format);

export const formatDateTime = (
    date: string | Date,
    format = "YYYY-MM-DD HH:mm:ss"
) => dayjs(date).format(format);

export const isDateToday = (date: string | Date) => dayjs(date).isToday();

export const getRelativeTimeFromNow = (date: string | Date) =>
    dayjs(date).fromNow();

export const isBefore = (date1: string | Date, date2: string | Date) =>
    dayjs(date1).isBefore(dayjs(date2));

export const isAfter = (date1: string | Date, date2: string | Date) =>
    dayjs(date1).isAfter(dayjs(date2));

export const isSameOrBeforeDate = (
    date1: string | Date,
    date2: string | Date
) => dayjs(date1).isSameOrBefore(dayjs(date2));

export const isSameOrAfterDate = (date1: string | Date, date2: string | Date) =>
    dayjs(date1).isSameOrAfter(dayjs(date2));

export const getWeekday = (date: string | Date) => dayjs(date).format("dddd"); // ex: "Monday"

export const toUTC = (date: string | Date) => dayjs(date).utc().format();

export const toKST = (date: string | Date) =>
    dayjs(date).tz("Asia/Seoul").format("YYYY-MM-DD HH:mm:ss");
